<div class="theme-editor-panel" [class.applied]="applied">
  <div class="theme-header" (click)="onHeaderClick()" [class.cursor-pointer]="!selected">
    <div class="overflow-hidden whitespace-nowrap flex items-center mr-1">
      @if (theme.scope === 'Blaze') {
        <mat-icon svgIcon="icon_blaze_24" class="theme-icon" />
      }
      <span
        class="font-medium overflow-ellipsis overflow-hidden whitespace-nowrap"
        [blazeTooltip]="theme.name"
        >{{ theme.name }}</span
      >
    </div>
    @if (!selected) {
      <div class="theme-colors" @fadeInOut>
        <div class="theme-color" [style.background-color]="theme.value.fill"></div>
        <div class="theme-color" [style.background-color]="theme.value.outline"></div>
        <div class="theme-color" [style.background-color]="theme.value.title"></div>
        <div class="theme-color" [style.background-color]="theme.value.value"></div>
        <div class="theme-color" [style.background-color]="theme.value.accent"></div>
        <div class="theme-color" [style.background-color]="theme.value.complementary"></div>
      </div>
    }
    @if (selected) {
      <div @fadeInOut class="flex items-center gap-8">
        @if (applied && !modified) {
          <span
            class="px-4 text-center text-11 font-medium uppercase text-base-white bg-accent rounded h-16 inline-block"
            >Applied</span
          >
        }
        @if (showDeleteButton) {
          <button type="button" blazeIconButton (click)="onDeleteClick()">
            <mat-icon svgIcon="icon_trash_16" />
          </button>
        }
        @if (showResetButton) {
          <button type="button" blazeIconButton (click)="onResetClick()">
            <mat-icon svgIcon="icon_reset_16" />
          </button>
        }
      </div>
    }
  </div>
  <div class="overflow-x-hidden overflow-y-auto relative" [@slideInOut]="selected">
    <div class="theme-editor-content">
      <ng-content />
    </div>
  </div>
</div>
